import {FC} from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';

export const AuthGuard: FC = () => {
  const location = useLocation();
  const isLoggedIn = !!sessionStorage.getItem('password');

  return isLoggedIn ? <Outlet /> : <Navigate to='/auth' state={{from: location}} replace />;
};
